import { render } from "./withdrawntabset.vue?vue&type=template&id=c334bd28"
import script from "./withdrawntabset.vue?vue&type=script&lang=js"
export * from "./withdrawntabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__